import { useDispatch, useSelector } from "react-redux";
import CalendarPeriodSelector from "../../sharedComponents/CalendarPeriodSelector/CalendarPeriodSelector.jsx";
import css from "./DateSelector.module.css";
import { useEffect, useState } from "react";
import { updateDates } from "../../../redux/crm/slice.js";
import { useCalendarPeriodStorage } from "../../../utils/useCalendarPeriodStorage.js";
import { selectDates } from "../../../redux/crm/selectors.js";
import { showToast } from "../../../utils/showToast.js";

export default function DateSelector() {
  const dispatch = useDispatch();
  const storedPeriod = JSON.parse(localStorage.getItem("crm-records-period"));
  const currentDate = new Date().toISOString().split("T")[0];
  const dates = useSelector(selectDates);
  const fromDate = dates?.startDate;
  const toDate = dates?.endDate;

  const [startDate, setStartDate] = useState(
    storedPeriod?.start ?? currentDate
  );
  const [endDate, setEndDate] = useState(storedPeriod?.end ?? currentDate);

  const [periodStartData, setPeriodStartData] = useState(startDate);
  const [periodEndData, setPeriodEndData] = useState(endDate);

  // const fetchPeriodRecords = useCallback(
  //   dates => {
  //     const { startDate, endDate } = dates;

  //     if (!startDate || !endDate) {
  //       toast.error("Потрібно обрати обидві дати!");
  //       return;
  //     }

  //     dispatch(getAllCars(dates));
  //   },
  //   [dispatch]
  // );

  useCalendarPeriodStorage({
    storageKey: "crm-records-period",
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  });

  useEffect(() => {
    if (!startDate && !endDate) {
      setPeriodStartData(currentDate);
      setPeriodEndData(currentDate);
      setStartDate(currentDate);
      setEndDate(currentDate);
    }
  }, [startDate, endDate, currentDate]);

  useEffect(() => {
    if (startDate && endDate) {
      const updatedDates = {
        startDate: formatToDate(new Date(startDate)),
        endDate: formatToDate(new Date(endDate)),
      };
      dispatch(updateDates(updatedDates));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (fromDate && toDate) {
      setPeriodStartData(fromDate);
      setPeriodEndData(toDate);
      setStartDate(fromDate);
      setEndDate(toDate);
    }
  }, [fromDate, toDate]);

  function formatToDate(date) {
    if (!date || !(date instanceof Date)) {
      console.error("Invalid date passed to formatToDate:", date);
      return null;
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function handleInputChangeBeg(date) {
    let newStartDate = date;
    if (periodEndData && date && new Date(date) > new Date(periodEndData)) {
      newStartDate = periodEndData;
      showToast("Кінцева дата не має перевищувати початкову!", "error");
    }

    setPeriodStartData(newStartDate);
    setStartDate(newStartDate);
    // console.log("newStartDate", newStartDate);

    if (newStartDate && periodEndData) {
      const updatedDates = {
        startDate: formatToDate(new Date(newStartDate)),
        endDate: formatToDate(new Date(periodEndData)),
      };
      // fetchPeriodRecords(updatedDates);
      dispatch(updateDates(updatedDates));
    }
  }

  function handleInputChangeEnd(date) {
    let newEndDate = date;
    if (periodStartData && date && new Date(date) < new Date(periodStartData)) {
      newEndDate = periodStartData;
    }

    setPeriodEndData(newEndDate);
    setEndDate(newEndDate);

    if (periodStartData && newEndDate) {
      const updatedDates = {
        startDate: formatToDate(new Date(periodStartData)),
        endDate: formatToDate(new Date(newEndDate)),
      };
      // console.log("updatedDates", updatedDates);

      // fetchPeriodRecords(updatedDates);
      dispatch(updateDates(updatedDates));
    }
  }

  return (
    <div className={css.container} data-tour-periodselector="step-1">
      <CalendarPeriodSelector
        periodStartData={periodStartData}
        periodEndData={periodEndData}
        startDate={startDate}
        endDate={endDate}
        handleInputChangeBeg={handleInputChangeBeg}
        handleInputChangeEnd={handleInputChangeEnd}
        isSingle={false}
      />
    </div>
  );
}
